<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0" cols="12">
        <span class="text-uppercase page-subtitle d-block">Templates</span>
        <h3 class="page-title d-inline">{{ pageTitle }}</h3>
        <router-link
          class="btn btn-success text-white float-right"
          v-if="showNewTemplateButton"
          :to="{ name: 'admin-quotation-template-new' }"
        >
          Novo template
        </router-link>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <d-card class="card-small mb-4">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="4">
                <h6 class="m-0">Template de orçamento</h6>
              </d-col>
            </d-row>
          </d-card-header>

          <template-form ref="templateForm" :key="$route.fullPath"/>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import TemplateForm from '_modules/quotation/components/TemplateForm.vue';

export default {
  name: 'quotation-template-edit',
  components: {
    TemplateForm,
  },
  computed: {
    pageTitle() {
      return this.$route.params.templateId ? 'Editar' : 'Novo';
    },
    showNewTemplateButton() {
      return this.$route.params.templateId;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    save() {
      this.$refs.templateForm.save();
    },
  },
};
</script>
